/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetCsrf200Response,
  PostLoginRequest,
} from '../models/index';
import {
    GetCsrf200ResponseFromJSON,
    GetCsrf200ResponseToJSON,
    PostLoginRequestFromJSON,
    PostLoginRequestToJSON,
} from '../models/index';

export interface PostLoginOperationRequest {
    postLoginRequest?: PostLoginRequest;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * HTTPヘッダに設定するためのCSRFトークンを取得する。 
     * CSRFトークンの取得
     */
    async getCsrfRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetCsrf200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csrf`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetCsrf200ResponseFromJSON(jsonValue));
    }

    /**
     * HTTPヘッダに設定するためのCSRFトークンを取得する。 
     * CSRFトークンの取得
     */
    async getCsrf(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetCsrf200Response> {
        const response = await this.getCsrfRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * ログインする
     */
    async postLoginRaw(requestParameters: PostLoginOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostLoginRequestToJSON(requestParameters['postLoginRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 
     * ログインする
     */
    async postLogin(requestParameters: PostLoginOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postLoginRaw(requestParameters, initOverrides);
    }

}
